<div class="layout-plugin-raiox">
  <router-outlet></router-outlet>
</div>
<div class="footer">
  <div>
    <span>© {{currentYear}} Auto Arremate.</span>
    <span>Todos os Direitos Reservados. <a (click)="openTermsConditionsModal()">Termos e
        condições de uso</a>.</span>
  </div>
</div>